import React, { useEffect, useState } from "react";
import "./css/styles.css";
import UserDetails from "./UserDetails";
import ButtonRow from "./ButtonRow";

import RequestList from "./RequestList";
import Header from "../Utills/Header";
import RejectionAlert from "./RejectionAlert";
import axios from "axios";
import AlertBox from "../Utills/AlertBox";
import MatchPopup from "./MatchPopup";

const initialValue = {
  alert: false,
  head: "",
  message: "",
  success: false,
  action: null
};

const ReqIndex = () => {
  const [buttonStatus, setButtonStatus] = useState(0);
  const [requests, setRequests] = useState([1, 2, 3, 4, 5]);
  const [modalOpen, setModalOpen] = useState(false);
  const [user, setUser] = useState();
  const [rejectionList, setRejectionList] = useState();
  const [alertOptions, setAlertOptions] = useState(initialValue);

  const handleAlert = (open, head, message, callback,success) => {
    setAlertOptions((prev) => ({
      ...prev,
      alert: open,
      head: head,
      message: message,
      callback: callback,
      success:success
    }));
  };

  const getUser = () => {
    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", localStorage.getItem("LangValue"));
    const url = localStorage.getItem("api_url");
    axios({
      method: "post",
      url: url + "webprofile",
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const response = res.data;
      console.log(response)
      if (response.status == false) {
        handleAlert(
          true,
          "Fetch request Failed",
          "The request to get the data of the user has been failed",
          null,
          false
        );
      } else {
        setUser(response.result);
      }
    });
  };



  useEffect(() => {
    getUser();
  }, []);

  const handleShiftPage = (value) => {
    setButtonStatus(value);
  };

  return (
    <>
      {" "}
      <Header name="Add Matches"/>
      <div className="request-container">
        <div className="content-container">
          <ButtonRow
            handleShiftPage={handleShiftPage}
            buttonStatus={buttonStatus}
          />
          {buttonStatus == 0 ? (
            <UserDetails user={user} handleAlert={handleAlert}/>
          ) : (
            <RequestList requests={requests} user={user} handleAlert={handleAlert}/>
          )}
        </div>
        <AlertBox options={alertOptions} />
        
      </div>
    </>
  );
};

export default ReqIndex;
